import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
export default {
  name: "turn",
  computed: {
    ...taskVuex.mapState(["taskInfo"]),
    ...userVuex.mapState(["userInfo", "balanceInfo"])
  },
  watch: {
    "taskInfo.popCoinAnim.isEnd": {
      async handler(bool) {
        if (bool) {
          await this.getSpinsBalance();
          // if (this.taskInfo.popCoinAnim.icon == "spins" || this.spinsBalanceInfo.balance < this.spinsBalanceInfo.max) {
          // }

          this.isBtnLoading = false;
        }
      }
    }
  },
  data() {
    return {
      luckyInfo: null,
      prizeList: null,
      prizeIndex: 0,
      isBtnLoading: false,
      prizeAllResult: null,
      isResultAnim: false,
      isPageLoading: true,
      isRefresh: false,
      popStockEnoughShow: false,
      spinsBalanceInfo: {
        balance: 0,
        max: 0,
        next_max: 0,
        recovery: {
          count: 0,
          countdown: 0
        }
      },
      calcBalanceTimer: 0,
      spinsRecoveryTimer: null,
      popRewardShow: false,
      rewardInfo: null,
      sellSpinsList: null,
      isSellSpinsLoading: false,
      popBuySpinsShow: false
    };
  },
  methods: {
    ...userVuex.mapMutations(["setUserInfo"]),
    onEnoughConfirm() {
      this.popStockEnoughShow = false;
      this.popBuySpinsShow = true;
    },
    accelerate(time = 2) {
      this.$nextTick(() => {
        const light1Ref = this.$refs.light1Ref;
        const light2Ref = this.$refs.light2Ref;
        light1Ref.style.animationDuration = `${time}s`;
        light2Ref.style.animationDuration = `${time}s`;
      });
    },
    getSellSpinsList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/spins/prices", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          const _data = data.map(item => {
            return {
              ...item,
              loading: false
            };
          });
          this.sellSpinsList = _data;
          resolve(_data);
        }, () => {
          resolve();
        });
      });
    },
    getSpinsBalance() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/spins/balance", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          const _data = {
            ...data,
            loading: false
          };
          this.spinsBalanceInfo = _data;
          this.$parent.spinsTagBalance = _data.balance;
          this.calcSpinsRecoveryTime();
          console.log("this.spinsBalanceInfo", this.spinsBalanceInfo);
          resolve(_data);
        }, () => {
          resolve();
        });
      });
    },
    calcSpinsRecoveryTime() {
      const spinsInfo = this.spinsBalanceInfo;
      const spinsBalance = spinsInfo.balance;
      const recovery = spinsInfo.recovery;
      clearTimeout(this.spinsRecoveryTimer);
      const calcFnc = async () => {
        recovery.countdown--;
        if (recovery.countdown <= 0 && spinsBalance < spinsInfo.max && this.calcBalanceTimer <= 5) {
          this.calcBalanceTimer++;
          clearTimeout(this.spinsRecoveryTimer);
          await this.getSpinsBalance();
          return;
        }
        if (recovery.countdown > 0) {
          this.calcBalanceTimer = 0;
          this.spinsRecoveryTimer = setTimeout(calcFnc, 2000);
        }
        if (spinsBalance >= spinsInfo.max) {
          this.calcBalanceTimer = 0;
        }
      };
      calcFnc();
    },
    setActivityConfig() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/list", {
          provider: "official",
          type: 0
        });
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: [],
        // };
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            this.luckyInfo = {};
          } else {
            this.luckyInfo = data[0];
          }
          resolve(this.luckyInfo);
        }, () => {
          resolve();
        });
      });
    },
    setLuckyList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/items", {
          lotteryId: this.luckyInfo.id
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (data.length <= 0) {
            resolve();
            return;
          }
          this.prizeList = [];
          data.forEach((item, index) => {
            this.prizeList.push({
              id: item.id,
              value: item.amount,
              type: item.currency
            });
          });
          console.log("this.prizeListthis.prizeList", this.prizeList);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    getLuckyResult() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/draw", {
          lotteryId: this.luckyInfo.id
        });
        if (!res) {
          resolve();
          return;
        }
        if (res.code == 0) {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          if (!data) {
            this.$toasted.clear();
            this.$toasted.error(res.message);
            resolve();
            return;
          }
          resolve(data);
        } else {
          if (res.code === 404) {
            this.initFnc();
            resolve();
            return;
          }
          this.$toasted.clear();
          this.$toasted.error(res.message);
        }
      });
    },
    async initFnc() {
      this.isPageLoading = true;
      const config = await this.setActivityConfig();
      if (!config) {
        this.isRefresh = false;
        return;
      }
      const items = await this.setLuckyList();
      if (!items) {
        this.isRefresh = false;
        return;
      }
      this.isPageLoading = false;
      console.log("itemsitemsitemsitemsitems", items);
    },
    async onStart() {
      if (this.spinsBalanceInfo.balance < this.luckyInfo.price_spins) {
        console.log("luckyInfo?.price_stock");
        this.popStockEnoughShow = true;
        return;
      }
      const vueLuckywheel = this.$refs.vueLuckywheel;
      if (!vueLuckywheel) {
        return;
      }
      if (this.isBtnLoading) return;
      this.isBtnLoading = true;
      this.accelerate(0.3);
      const res = await this.getLuckyResult();
      this.spinsBalanceInfo.balance -= this.luckyInfo.price_spins;
      if (!res) {
        this.isBtnLoading = false;
        return;
      }
      this.prizeAllResult = res;
      this.prizeIndex = this.prizeList.findIndex(item => {
        return item.id === res.winning_item.id;
      });
      console.log("this.prizeIndex", this.prizeIndex);
      if (this.prizeIndex == -1) {
        this.spinsBalanceInfo.balance += this.luckyInfo.price_spins;
        this.isBtnLoading = false;
        return;
      }
      this.$nextTick(vueLuckywheel.draw);
    },
    async onResult() {
      this.isResultAnim = true;
      await new Promise(resolve => setTimeout(resolve, 800));
      this.accelerate();
      this.isResultAnim = false;
      this.taskInfo.popCoinAnim.reward = this.prizeAllResult.winning_item.amount;
      this.taskInfo.popCoinAnim.userInfo = this.prizeAllResult.user;
      this.taskInfo.popCoinAnim.icon = this.prizeAllResult.winning_item.currency.toLowerCase();
      if (this.taskInfo.popCoinAnim.icon == "spins") {
        this.taskInfo.popCoinAnim.endId = "spinsBalanceId";
      } else if (this.taskInfo.popCoinAnim.icon == "coin") {
        this.taskInfo.popCoinAnim.endId = "coinBalanceId";
      }
      // this.$set(this.rewardInfo, "reward", this.prizeAllResult.winning_item.amount);
      // this.$set(this.rewardInfo, "icon", this.prizeAllResult.winning_item.currency.toLowerCase());
      // this.$set(this.rewardInfo, "userInfo", this.prizeAllResult.user);
      // this.$set(this.rewardInfo, "type", this.prizeAllResult.winning_item.currency);
      this.taskInfo.popCoinAnim.show = true;
    },
    async onRefresh() {
      this.isRefresh = true;
      await this.initFnc();
    },
    onAccept() {
      // this.taskInfo.popCoinAnim.icon = this.rewardInfo.type.toLowerCase();
      // this.taskInfo.popCoinAnim.userInfo = this.rewardInfo.userInfo;
      // this.taskInfo.popCoinAnim.reward = this.rewardInfo.reward;
      // this.taskInfo.popCoinAnim.show = true;
    },
    async onPaySpins(item) {
      if (item.loading) return;
      item.loading = true;
      const res = await this.$http.post("/lucky/spins/deposit", {
        priceId: item.id
      });
      if (res.code == 0) {
        const data = res.data;
        if (!data) {
          item.loading = false;
          return;
        }
        if (!data) {
          this.$toasted.clear();
          this.$toasted.error(res.message);
          item.loading = false;
          return;
        }
        this.popBuySpinsShow = false;
        this.taskInfo.popCoinAnim.isEnd = false;
        this.taskInfo.popCoinAnim.icon = "spins";
        this.taskInfo.popCoinAnim.endId = "spinsBalanceId";
        this.taskInfo.popCoinAnim.reward = item.spin;
        this.taskInfo.popCoinAnim.show = true;
        item.loading = false;
      } else {
        item.loading = false;
        this.$toasted.clear();
        this.$toasted.error(res.message);
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      this.setWowAnim();
      this.accelerate();
      await this.getSpinsBalance();
      await this.initFnc();
      await this.getSellSpinsList();
    });
  }
};